/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const CirclePlay = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 19 19">
      <g>
        <path d="M9.5,18 C4.813,18 1,14.187 1,9.5 C1,4.813 4.813,1 9.5,1 C14.187,1 18,4.813 18,9.5 C18,14.187 14.187,18 9.5,18 M9.5,0 C4.262,0 0,4.262 0,9.5 C0,14.738 4.262,19 9.5,19 C14.738,19 19,14.738 19,9.5 C19,4.262 14.738,0 9.5,0" />
        <path d="M8,11.6172 L8,7.3832 L11.528,9.5002 L8,11.6172 Z M7.757,6.0712 C7.603,5.9772 7.41,5.9762 7.254,6.0642 C7.097,6.1532 7,6.3202 7,6.5002 L7,12.5002 C7,12.6792 7.097,12.8462 7.254,12.9352 C7.33,12.9782 7.415,13.0002 7.5,13.0002 C7.589,13.0002 7.678,12.9762 7.757,12.9292 L12.757,9.9292 C12.908,9.8392 13,9.6762 13,9.5002 C13,9.3242 12.908,9.1612 12.757,9.0712 L7.757,6.0712 Z" />
      </g>
    </BaseSvgIcon>
  )
}

export default CirclePlay
